export default __webpack_public_path__ + "static/media/BackBlue.17c63e7a.svg";